import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import ReactStrapTable from 'components/reactStrapTable';
import { cellRendererCheck, dateFormate, currencyFormat } from 'utils/columns';
import useAxios from 'hooks/useAxios';
import Loader from 'components/Loader';

let tableDataBackup = [],
    rowForEdit = {},
    updatedFields = {};

const PharmacySummaryTable = (props) => {

    const {
        data,
        totalSize,
        onPageChange,
        filters,
        onSearchColumnFilters = () => '',
        onExport,
        lastDataRow,
        coveredEntity,
        refetch,
        loading,
        module,
        onClaimsRowClick,
        searchTerms,
        dateid,
        toggleSider,
        collapseSider
    } = props;
    const API = useAxios();
    tableDataBackup = data;

    const [tableData, setTableData] = useState(tableDataBackup);
    const [reset, setReset] = useState(false);
    const [claimID, setClaimID] = useState('');
    const [colFilters, setColFilters] = useState({});
    const [hasExportPermission, setHasExportPermission] = useState(false);
    const [isReasonOpen, setIsReasonOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState();

    useEffect(() => {
        setTableData(data);
        tableDataBackup = data;
    }, [data]);

    const handleReason = (row) => {
        setIsReasonOpen(!isReasonOpen);
        setSelectedRow(row);
    };

    const cellRendererNDC = (row) => {
        const { noOfClaims, isFooterRow } = row;
        if (noOfClaims && !isFooterRow) {
            return (
                <span
                    className='cursor-pointer text-decoration-underline'
                    onClick={() => handlClick(row)}
                >
                    {noOfClaims}
                </span>
            );
        }
        else if (noOfClaims && isFooterRow) {
            return (
                noOfClaims
            );
        }
        return '-';
    };

    const handlClick = (rowData) => {
        onClaimsRowClick(rowData);
    };

    const cellRendererReason = (row) => {
        const { reason } = row;
        if (reason) {
            return (
                <span
                    className='cursor-pointer text-decoration-underline'
                    onClick={() => handleReason(row)}
                >
                    {reason}
                </span>
            );
        }
        return '-';
    };

    const columns = [{
        dataField: 'edit',
        text: 'Options',
        width: 100,
        show: true,
        disabled: true,
        hideColFilter: true,
        action: true,
    },
    {
        dataField: 'coveredEntity',
        text: 'Covered Entity/OPAID',
        sort: true,
        width: 410,
        show: true,
        inputType: 'text',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'chainPharmacy',
        text: 'Chain Pharmacy',
        sort: true,
        width: 310,
        show: true,
        inputType: 'text',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'pharmacyName',
        text: 'Pharmacy',
        sort: true,
        width: 230,
        show: true,
        inputType: 'text',
        // hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
        dataField: 'pharmacyNPI',
        text: 'Pharmacy NABP/NPI',
        sort: true,
        width: 230,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
        dataField: 'claimType',
        text: 'Claim Type',
        sort: false,
        width: 120,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
        showColumn: true
    },
    // {
    //     dataField: 'claimSubType',
    //     text: 'Claim Sub Type',
    //     sort: false,
    //     width: 120,
    //     show: true,
    //     inputType: 'text',
    //     hideColFilter: true,
    //     cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    //     showColumn: true
    // },
    {
        dataField: 'noOfClaims',
        text: 'No. of Claims',
        sort: false,
        width: 110,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererNDC(rowData),
        showColumn: true
    },
    {
        dataField: 'coPay',
        text: 'Co-pay',
        sort: false,
        width: 140,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    {
        dataField: 'planPaidAmount',
        text: 'Plan Paid Amount',
        sort: false,
        width: 180,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
        showColumn: true
    },
    {
        dataField: 'totalPayment',
        text: 'Total Paid',
        sort: false,
        width: 140,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    {
        dataField: 'customDispenseFee',
        text: 'Dispensing Fee',
        sort: false,
        width: 140,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    {
        dataField: 'estWACRetailCost',
        text: 'Est. WAC Retail Cost',
        sort: false,
        width: 190,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    {
        dataField: 'estNon340BNetProfit',
        text: 'Est. Non 340B Net Profit',
        sort: false,
        width: 190,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
     {
        dataField: 'truedUpCost',
        text: 'Trued-Up Cost',
        sort: false,
        width: 190,
        show: true,
        inputType: 'number',
        hideColFilter: true,
        cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    ];

    const onHandleSort = (filter, hasColFilter) => {
        filter.DateRangeId = dateid ? dateid : searchTerms.dateRangeID;
        if (filter.dateRangeID == 7) {
            filter.StartDate = searchTerms.startDate;
            filter.EndDate = searchTerms.endDate == '' ? new Date() : searchTerms.endDate;
        }
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        filter.DateRangeId = dateid ? dateid : searchTerms.dateRangeID;
        if (filter.dateRangeID == 7) {
            filter.StartDate = searchTerms.startDate;
            filter.EndDate = searchTerms.endDate == '' ? new Date() : searchTerms.endDate;
        }
        if (hasColFilter) {
            const colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        onPageChange(filter);
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        filter.DateRangeId = dateid ? dateid : searchTerms.dateRangeID;
        if (filter.dateRangeID == 7) {
            filter.StartDate = searchTerms.startDate;
            filter.EndDate = searchTerms.endDate == '' ? new Date() : searchTerms.endDate;
        }
        if (hasColFilter) {
            const colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            onPageChange(filter);
        }
    };

    const handleSearchColumnFilters = (colFilter) => {

        if (onSearchColumnFilters) {
            onSearchColumnFilters(colFilter);
            setColFilters(colFilter);
        }
    };

    const handleFilterCancel = () => {

        refetch();
    };

    return (
        <>
            {loading && <Loader opacity={0.01} colour='black' />}
            {/* <div
                className='table-card scroll-table position-relative border-0 rounded pt-0'
                fixed-height={tableData.length > 0 ? 'fixed-height' : 'default'}
            > */}
            <div
                className="table-card scroll-table position-relative border-0 rounded pt-0"
                fixed-height={data.length > 0 ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}` : "default"}
            >
                <ReactStrapTable
                    id='pharmacy-summary-table'
                    height={550}
                    fixedColumn
                    width={1200}
                    reset={reset}
                    hasPagination
                    data={tableData}
                    columns={columns}
                    onExport={onExport}
                    filters={filters}
                    totalRecords={totalSize}
                    pageSize={filters.pageSize}
                    currentPage={filters.currentPage}
                    handleSort={onHandleSort}
                    onPageChange={onHandlePageChange}
                    onPageSizeChange={onPageSizeChange}
                    onFilterCancel={handleFilterCancel}
                    onSearchColumnFilters={handleSearchColumnFilters}
                    toggleSider={toggleSider}
                    collapseSider={collapseSider}
                    lastDataRow={lastDataRow}
                // hasExportPermission={hasExportPermission}
                />
                {/* <FallourReasonsModal isOpen={isReasonOpen} toggle={handleReason} row={selectedRow} /> */}
            </div>
        </>
    );
};
export default PharmacySummaryTable;
